// import React, { useState, useEffect } from 'react';

// // Caption Modal Component - allows users to add optional captions before uploading
// export const CaptionModal = ({ files, onConfirm, onCancel }) => {
//   const [captions, setCaptions] = useState([]);
//   const [previews, setPreviews] = useState([]);

//   useEffect(() => {
//     if (!files || files.length === 0) return;

//     // Initialize captions array
//     setCaptions(new Array(files.length).fill(''));
    
//     // Create preview URLs for all files
//     const previewUrls = files.map(file => URL.createObjectURL(file));
//     setPreviews(previewUrls);

//     // Cleanup preview URLs on unmount
//     return () => {
//       previewUrls.forEach(url => URL.revokeObjectURL(url));
//     };
//   }, [files]);

//   useEffect(() => {
//     if (files) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = '';
//     }
//     return () => {
//       document.body.style.overflow = '';
//     };
//   }, [files]);

//   if (!files || files.length === 0) return null;

//   const handleCaptionChange = (index, value) => {
//     // Enforce 100 character limit
//     const trimmedValue = value.slice(0, 100);
//     const newCaptions = [...captions];
//     newCaptions[index] = trimmedValue;
//     setCaptions(newCaptions);
//   };

//   const handleConfirm = () => {
//     // Return captions array (may include empty strings, which will be treated as null)
//     const finalCaptions = captions.map(cap => cap.trim() || null);
//     onConfirm(finalCaptions);
//   };

//   return (
//     <div 
//       style={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         background: 'rgba(49,35,16,0.85)',
//         backdropFilter: 'blur(10px)',
//         zIndex: 10002,
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '20px',
//         paddingTop: 'calc(20px + env(safe-area-inset-top))',
//         paddingBottom: 'calc(20px + env(safe-area-inset-bottom))',
//         paddingLeft: 'calc(20px + env(safe-area-inset-left))',
//         paddingRight: 'calc(20px + env(safe-area-inset-right))'
//       }}
//       onClick={onCancel}
//     >
//       <div 
//         style={{
//           background: '#aeb4b8',
//           border: '1px solid rgba(198,162,91,0.4)',
//           borderRadius: '12px',
//           padding: '24px',
//           maxWidth: '500px',
//           width: '100%',
//           maxHeight: '90vh',
//           overflowY: 'auto',
//           boxShadow: '0 8px 32px rgba(49,35,16,0.4)',
//           animation: 'slideDown 0.3s ease'
//         }}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <h3 style={{
//           fontFamily: "'Apple Garamond', Garamond, 'Times New Roman', serif",
//           fontSize: 'clamp(1.2em, 4vw, 1.6em)',
//           color: '#312310',
//           letterSpacing: '0.05em',
//           fontWeight: 400,
//           margin: '0 0 20px 0',
//           textAlign: 'center'
//         }}>
//           Add Captions (Optional)
//         </h3>

//         <p style={{
//           fontFamily: "'Montserrat', sans-serif",
//           fontSize: 'clamp(0.75em, 2.5vw, 0.85em)',
//           color: '#553918',
//           letterSpacing: '0.02em',
//           lineHeight: 1.6,
//           margin: '0 0 24px 0',
//           textAlign: 'center'
//         }}>
//           Add captions to your images (max 100 characters each). Captions are optional.
//         </p>

//         <div style={{
//           display: 'flex',
//           flexDirection: 'column',
//           gap: '20px',
//           marginBottom: '24px'
//         }}>
//           {files.map((file, index) => (
//             <div 
//               key={index}
//               style={{
//                 background: 'rgba(174,180,184,0.6)',
//                 border: '1px solid rgba(130,85,30,0.3)',
//                 borderRadius: '8px',
//                 padding: '16px',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '12px'
//               }}
//             >
//               {/* Thumbnail */}
//               <div style={{
//                 width: '100%',
//                 maxHeight: '150px',
//                 overflow: 'hidden',
//                 borderRadius: '6px',
//                 border: '1px solid rgba(130,85,30,0.2)',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 background: 'rgba(49,35,16,0.1)'
//               }}>
//                 <img 
//                   src={previews[index]} 
//                   alt={`Preview ${index + 1}`}
//                   style={{
//                     maxWidth: '100%',
//                     maxHeight: '150px',
//                     objectFit: 'contain'
//                   }}
//                 />
//               </div>

//               {/* Caption Input */}
//               <div>
//                 <textarea
//                   value={captions[index] || ''}
//                   onChange={(e) => handleCaptionChange(index, e.target.value)}
//                   placeholder={`Caption for image ${index + 1} (optional)`}
//                   maxLength={100}
//                   style={{
//                     width: '100%',
//                     minHeight: '60px',
//                     padding: '10px 12px',
//                     fontFamily: "'Montserrat', sans-serif",
//                     fontSize: '14px',
//                     color: '#312310',
//                     background: 'rgba(255,255,255,0.7)',
//                     border: '1px solid rgba(130,85,30,0.3)',
//                     borderRadius: '6px',
//                     resize: 'vertical',
//                     letterSpacing: '0.02em',
//                     lineHeight: 1.5
//                   }}
//                 />
//                 <div style={{
//                   display: 'flex',
//                   justifyContent: 'flex-end',
//                   marginTop: '4px'
//                 }}>
//                   <span style={{
//                     fontFamily: "'Montserrat', sans-serif",
//                     fontSize: '12px',
//                     color: captions[index]?.length >= 100 ? '#82551e' : '#553918',
//                     letterSpacing: '0.02em'
//                   }}>
//                     {(captions[index] || '').length}/100
//                   </span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Buttons */}
//         <div style={{
//           display: 'flex',
//           gap: '12px',
//           justifyContent: 'flex-end'
//         }}>
//           <button
//             onClick={onCancel}
//             style={{
//               padding: '10px 20px',
//               background: 'rgba(162,169,172,0.5)',
//               border: '1px solid rgba(130,85,30,0.3)',
//               color: '#312310',
//               fontFamily: "'Montserrat', sans-serif",
//               fontSize: 'clamp(0.7em, 2vw, 0.8em)',
//               letterSpacing: '0.1em',
//               textTransform: 'uppercase',
//               fontWeight: 400,
//               cursor: 'pointer',
//               borderRadius: '4px',
//               transition: 'all 0.3s ease',
//               minHeight: '44px',
//               minWidth: '100px',
//               WebkitTapHighlightColor: 'transparent'
//             }}
//             onMouseOver={(e) => {
//               e.target.style.background = 'rgba(162,169,172,0.7)';
//             }}
//             onMouseOut={(e) => {
//               e.target.style.background = 'rgba(162,169,172,0.5)';
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleConfirm}
//             style={{
//               padding: '10px 20px',
//               background: '#312310',
//               border: '1px solid rgba(198,162,91,0.4)',
//               color: '#e6c57e',
//               fontFamily: "'Montserrat', sans-serif",
//               fontSize: 'clamp(0.7em, 2vw, 0.8em)',
//               letterSpacing: '0.1em',
//               textTransform: 'uppercase',
//               fontWeight: 400,
//               cursor: 'pointer',
//               borderRadius: '4px',
//               transition: 'all 0.3s ease',
//               minHeight: '44px',
//               minWidth: '120px',
//               WebkitTapHighlightColor: 'transparent'
//             }}
//             onMouseOver={(e) => {
//               e.target.style.background = '#553918';
//             }}
//             onMouseOut={(e) => {
//               e.target.style.background = '#312310';
//             }}
//           >
//             Upload
//           </button>
//         </div>
//       </div>

//       <style>{`
//         @keyframes slideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//       `}</style>
//     </div>
//   );
// };



import React, { useState, useEffect } from 'react';

export const CaptionModal = ({ files, onConfirm, onCancel }) => {
  const [captions, setCaptions] = useState([]);
  const [previews, setPreviews] = useState([]);

  // Handle File Previews & Memory Management
  useEffect(() => {
    if (!files || files.length === 0) return;

    // Only reset captions if the file count changes to prevent data loss on parent re-renders
    setCaptions(prev => (prev.length === files.length ? prev : new Array(files.length).fill('')));

    // Create generic object URLs
    const urls = files.map(file => URL.createObjectURL(file));
    setPreviews(urls);

    // Cleanup function to prevent memory leaks
    return () => {
      urls.forEach(url => URL.revokeObjectURL(url));
    };
  }, [files]);

  // Lock Body Scroll
  useEffect(() => {
    if (files && files.length > 0) {
      document.body.style.overflow = 'hidden';
    }
    return () => { document.body.style.overflow = ''; };
  }, [files]);

  if (!files || files.length === 0) return null;

  const handleCaptionChange = (index, value) => {
    const trimmedValue = value.slice(0, 100);
    const newCaptions = [...captions];
    newCaptions[index] = trimmedValue;
    setCaptions(newCaptions);
  };

  const handleConfirm = () => {
    const finalCaptions = captions.map(cap => cap?.trim() || null);
    onConfirm(finalCaptions);
  };

  return (
    <div style={styles.overlay} onClick={onCancel}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        
        {/* Header */}
        <div style={styles.header}>
          <h3 style={styles.title}>Upload Details</h3>
          <p style={styles.subtitle}>Add captions to your photos ({files.length})</p>
        </div>

        {/* Scrollable Content */}
        <div style={styles.scrollArea}>
          {files.map((file, index) => (
            <div key={index} style={styles.card}>
              
              {/* Image Preview */}
              <div style={styles.imageContainer}>
                <img 
                  src={previews[index]} 
                  alt={`Preview ${index}`} 
                  style={styles.image} 
                />
              </div>

              {/* Input Area */}
              <div style={styles.inputWrapper}>
                <textarea
                  value={captions[index] || ''}
                  onChange={(e) => handleCaptionChange(index, e.target.value)}
                  placeholder="Add a caption..."
                  style={styles.textarea}
                />
                <span style={{
                  ...styles.charCount,
                  color: (captions[index]?.length || 0) >= 100 ? '#ff3b30' : 'rgba(255,255,255,0.4)'
                }}>
                  {100 - (captions[index]?.length || 0)}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Action Bar */}
        <div style={styles.actionBar}>
          <button 
            onClick={onCancel} 
            style={styles.cancelButton}
            onMouseEnter={e => e.target.style.background = 'rgba(255,255,255,0.1)'}
            onMouseLeave={e => e.target.style.background = 'transparent'}
          >
            Cancel
          </button>
          <button 
            onClick={handleConfirm} 
            style={styles.confirmButton}
            onMouseEnter={e => e.target.style.transform = 'scale(1.02)'}
            onMouseLeave={e => e.target.style.transform = 'scale(1)'}
          >
            Upload {files.length} Item{files.length !== 1 ? 's' : ''}
          </button>
        </div>

      </div>
      <style>{`
        @keyframes iosSlideUp {
          from { opacity: 0; transform: scale(0.95) translateY(20px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
        /* Custom Scrollbar for Webkit */
        ::-webkit-scrollbar { width: 0px; background: transparent; }
      `}</style>
    </div>
  );
};

// iOS "Frosted Glass" Design System
const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)', // Dim background
    backdropFilter: 'blur(15px)', // The heavy background blur
    WebkitBackdropFilter: 'blur(15px)',
    zIndex: 10002,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  modal: {
    width: '100%',
    maxWidth: '460px',
    maxHeight: '85vh',
    display: 'flex',
    flexDirection: 'column',
    // The "Frosted Glass" Material
    backgroundColor: 'rgba(30, 30, 30, 0.75)',
    backdropFilter: 'blur(40px) saturate(180%)',
    WebkitBackdropFilter: 'blur(40px) saturate(180%)',
    border: '1px solid rgba(255, 255, 255, 0.12)',
    borderRadius: '24px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
    overflow: 'hidden',
    animation: 'iosSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  },
  header: {
    padding: '24px 24px 16px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    textAlign: 'center',
    flexShrink: 0,
  },
  title: {
    margin: 0,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: '18px',
    fontWeight: '600',
    color: '#ffffff',
    letterSpacing: '-0.01em',
  },
  subtitle: {
    margin: '6px 0 0',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: '13px',
    color: 'rgba(255, 255, 255, 0.5)',
  },
  scrollArea: {
    overflowY: 'auto',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    flex: 1,
  },
  card: {
    display: 'flex',
    gap: '16px',
    padding: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    alignItems: 'center',
  },
  imageContainer: {
    width: '70px',
    height: '70px',
    borderRadius: '12px',
    overflow: 'hidden',
    flexShrink: 0,
    backgroundColor: '#000',
    border: '1px solid rgba(255,255,255,0.1)',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  inputWrapper: {
    flex: 1,
    position: 'relative',
  },
  textarea: {
    width: '100%',
    background: 'transparent',
    border: 'none',
    color: '#fff',
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: '16px',
    lineHeight: '1.4',
    resize: 'none',
    outline: 'none',
    minHeight: '24px',
    padding: '0 25px 0 0', // Space for counter
  },
  charCount: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    fontSize: '10px',
    fontWeight: '600',
  },
  actionBar: {
    padding: '16px 24px 24px',
    borderTop: '1px solid rgba(255, 255, 255, 0.08)',
    display: 'flex',
    gap: '12px',
    flexShrink: 0,
    background: 'rgba(30, 30, 30, 0.4)', // Slight darken for bottom area
  },
  cancelButton: {
    padding: '14px 20px',
    borderRadius: '14px',
    border: 'none',
    background: 'transparent',
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background 0.2s',
    fontFamily: '-apple-system, sans-serif',
  },
  confirmButton: {
    flex: 1,
    padding: '14px 20px',
    borderRadius: '14px',
    border: 'none',
    // The Apple Blue Gradient or Solid White
    background: '#ffffff', 
    color: '#000000',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
    fontFamily: '-apple-system, sans-serif',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
  }
};